/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../Components/CustomButtons/Button.js";
import styles from "../../assets/jss/material-kit-react/components/footerStyle.js";
import "./Footer.css";
const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  return (
    <footer className={footerClasses} style={{marginTop:80}}>
      <div className={classes.container}>
        <List className="list container">
          <ListItem 
            style={{ }}
            className={classes.inlineBlock + " listItem"}
          >
            <Button
              color="transparent"
              href="https://github.com/ankur-b"
              target="_blank"
            >
              <i className={classes.socialIcons + " fab fa-github"} />
            </Button>
          </ListItem>
          <ListItem
            style={{}}
            className={classes.inlineBlock + " listItem"}
          >
            <Button
              href="https://twitter.com/archman07"
              target="_blank"
              color="transparent"
              className="button"
            >
              <i className={classes.socialIcons + " fab fa-twitter"} />
            </Button>
          </ListItem>
          <ListItem
            style={{}}
            className={classes.inlineBlock + " listItem"}
          >
            <Button
              color="transparent"
              href="https://www.facebook.com/archman07"
              target="_blank"
              className="Button"
            >
              <i className={classes.socialIcons + " fab fa-facebook"} />
            </Button>
          </ListItem>
          <ListItem
            style={{}}
            className={classes.inlineBlock + " listItem"}
          >
            <Button
              color="transparent"
              href="https://www.instagram.com/archman07"
              target="_blank"
            >
              <i className={classes.socialIcons + " fab fa-instagram"} />
            </Button>
          </ListItem>
          <ListItem
            style={{}}
            className={classes.inlineBlock + " listItem"}
          >
            <Button
              color="transparent"
              href="https://www.linkedin.com/in/ankur-barve29"
              target="_blank"
            >
              <i className={classes.socialIcons + " fab fa-linkedin"} />
            </Button>
          </ListItem>
          <ListItem
            style={{}}
            className={classes.inlineBlock + " listItem"}
          >
            <Button
              color="transparent"
              href="mailto:ankurbarve29@gmail.com"
              target="_blank"
            >
              <i className={classes.socialIcons + " far fa-envelope-open"} />
            </Button>
          </ListItem>
        </List>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool,
};
